module.exports = __webpack_public_path__ + "img/siemens.899ba41b.png";